import UrlEndpoints from "../client/UrlEndpoints";
import axios from 'axios';
import {
    TRANSLATE_LOADING_ACTION,
    TRANSLATE_GET_USERS_SUCCESS_ACTION,
    TRANSLATE_GET_USERS_ERROR_ACTION,
    TRANSLATE_POST_USER_DATA_SUCCESS_ACTION,
    TRANSLATE_POST_USER_DATA_ERROR_ACTION,
    TRANSLATE_GET_USER_SUCCESS_ACTION,
    TRANSLATE_GET_USER_ERROR_ACTION,
    TRANSLATE_PATCH_USER_DATA_SUCCESS_ACTION,
    TRANSLATE_PATCH_USER_DATA_ERROR_ACTION,
    TRANSLATE_DEACTIVATE_USER_SUCCESS_ACTION,
    TRANSLATE_DEACTIVATE_USER_ERROR_ACTION,
    TRANSLATE_ACTIVATE_USER_SUCCESS_ACTION,
    TRANSLATE_ACTIVATE_USER_ERROR_ACTION
} from "../translates/Translates";
import {getRequestConfig} from '../client/helpers/Helper';

export const GET_USERS = 'GET_USERS';
export const SET_LOADING_GET_USERS = 'SET_LOADING_GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';

export const POST_USER_DATA = 'POST_USER_DATA';
export const SET_LOADING_POST_USER_DATA = 'SET_LOADING_POST_USER_DATA';
export const POST_USER_DATA_SUCCESS = 'POST_USER_DATA_SUCCESS';
export const POST_USER_DATA_ERROR = 'POST_USER_DATA_ERROR';

export const GET_USER = 'GET_USER';
export const SET_LOADING_GET_USER = 'SET_LOADING_GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_ERROR = 'GET_USER_ERROR';

export const PATCH_USER_DATA = 'PATCH_USER_DATA';
export const SET_LOADING_PATCH_USER_DATA = 'SET_LOADING_PATCH_USER_DATA';
export const PATCH_USER_DATA_SUCCESS = 'PATCH_USER_DATA_SUCCESS';
export const PATCH_USER_DATA_ERROR = 'PATCH_USER_DATA_ERROR';

export const DEACTIVATE_USER = 'DEACTIVATE_USER';
export const SET_LOADING_DEACTIVATE_USER = 'SET_LOADING_DEACTIVATE_USER';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_ERROR = 'DEACTIVATE_USER_ERROR';

export const ACTIVATE_USER = 'ACTIVATE_USER';
export const SET_LOADING_ACTIVATE_USER = 'SET_LOADING_ACTIVATE_USER';
export const ACTIVATE_USER_SUCCESS = 'ACTIVATE_USER_SUCCESS';
export const ACTIVATE_USER_ERROR = 'ACTIVATE_USER_ERROR';

const getUsers = () => {
    let url = UrlEndpoints.GET_USERS;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: GET_USERS,
        payload: axios.get(request_url, request_config)
    }
}

const setLoadingGetUsers = () => {
    return {
        type: SET_LOADING_GET_USERS,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getUsersSuccess = () => {
    return {
        type: GET_USERS_SUCCESS,
        payload: TRANSLATE_GET_USERS_SUCCESS_ACTION
    }
}

const getUsersError = () => {
    return {
        type: GET_USERS_ERROR,
        payload: TRANSLATE_GET_USERS_ERROR_ACTION
    }
}

const setLoadingPostUserData = () => {
    return {
        type: SET_LOADING_POST_USER_DATA,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const postUserData = (userData) => {
    let url = UrlEndpoints.POST_USER_DATA;
    let request_url = UrlEndpoints.getUrlEndpoint(url);
    let request_config = {};
    request_config = getRequestConfig();
    request_config.headers["content-type"] = "multipart/form-data";
    request_config.headers["accept"] = "multipart/form-data";
    let data = new FormData();
    data.append('file_photo', userData.photo);
    data.append('document', JSON.stringify(userData));
    return {
        type: POST_USER_DATA,
        payload: axios.post(request_url, request_config)
    }
}

const postUserDataSuccess = () => {
    return {
        type: POST_USER_DATA_SUCCESS,
        payload: TRANSLATE_POST_USER_DATA_SUCCESS_ACTION
    }
}

const postUserDataError = () => {
    return {
        type: POST_USER_DATA_ERROR,
        payload: TRANSLATE_POST_USER_DATA_ERROR_ACTION
    }
}

const getUser = (user_id) => {
    let url = UrlEndpoints.GET_USER;
    let request_url = UrlEndpoints.getUrlEndpoint(url, user_id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: GET_USER,
        payload: axios.get(request_url, request_config)
    }
}

const setLoadingGetUser = () => {
    return {
        type: SET_LOADING_GET_USER,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const getUserSuccess = () => {
    return {
        type: GET_USER_SUCCESS,
        payload: TRANSLATE_GET_USER_SUCCESS_ACTION
    }
}

const getUserError = () => {
    return {
        type: GET_USER_ERROR,
        payload: TRANSLATE_GET_USER_ERROR_ACTION
    }
}

const setLoadingPatchUserData = () => {
    return {
        type: SET_LOADING_PATCH_USER_DATA,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const patchUserData = (userData) => {
    let url = UrlEndpoints.PATCH_USER_DATA;
    let request_url = UrlEndpoints.getUrlEndpoint(url, userData.id);
    let request_config = {};
    request_config = getRequestConfig();
    let data = new FormData();
    data.append('file_photo', userData.photo);
    data.append('document', JSON.stringify(userData));
    return {
        type: PATCH_USER_DATA,
        payload: axios.patch(request_url, data, request_config)
    }
}

const patchUserDataSuccess = () => {
    return {
        type: PATCH_USER_DATA_SUCCESS,
        payload: TRANSLATE_PATCH_USER_DATA_SUCCESS_ACTION
    }
}

const patchUserDataError = () => {
    return {
        type: PATCH_USER_DATA_ERROR,
        payload: TRANSLATE_PATCH_USER_DATA_ERROR_ACTION
    }
}

const setLoadingDeactivateUser = () => {
    return {
        type: SET_LOADING_DEACTIVATE_USER,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const deactivateUser = (id) => {
    let request_url = UrlEndpoints.getUrlEndpoint(UrlEndpoints.DEACTIVATE_USER, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: DEACTIVATE_USER,
        payload: axios.post(request_url, request_config)
    }
}

const deactivateUserSuccess = () => {
    return {
        type: DEACTIVATE_USER_SUCCESS,
        payload: TRANSLATE_DEACTIVATE_USER_SUCCESS_ACTION
    }
}

const deactivateUserError = () => {
    return {
        type: DEACTIVATE_USER_ERROR,
        payload: TRANSLATE_DEACTIVATE_USER_ERROR_ACTION
    }
}


const setLoadingActivateUser = () => {
    return {
        type: SET_LOADING_ACTIVATE_USER,
        payload: TRANSLATE_LOADING_ACTION
    }
}

const activateUser = (id) => {
    let request_url = UrlEndpoints.getUrlEndpoint(UrlEndpoints.ACTIVATE_USER, id);
    let request_config = {};
    request_config = getRequestConfig();
    return {
        type: ACTIVATE_USER,
        payload: axios.post(request_url, request_config)
    } 
}

const activateUserSuccess = () => {
    return {
        type: ACTIVATE_USER_SUCCESS,
        payload: TRANSLATE_ACTIVATE_USER_SUCCESS_ACTION
    }
}

const activateUserError = () => {
    return {
        type: ACTIVATE_USER_ERROR,
        payload: TRANSLATE_ACTIVATE_USER_ERROR_ACTION
    }
}

export {
    getUsers,
    setLoadingGetUsers,
    getUsersError,
    getUsersSuccess,
    setLoadingPostUserData,
    postUserData,
    postUserDataSuccess,
    postUserDataError,
    getUser,
    setLoadingGetUser,
    getUserError,
    getUserSuccess,
    setLoadingPatchUserData,
    patchUserData,
    patchUserDataSuccess,
    patchUserDataError,
    setLoadingDeactivateUser,
    deactivateUser,
    deactivateUserSuccess,
    deactivateUserError,
    setLoadingActivateUser,
    activateUser,
    activateUserSuccess,
    activateUserError
}
